<app-header></app-header>
<div class="header-fix"></div>
<router-outlet></router-outlet>
<app-footer></app-footer>
